export function flatAdvanceForm(advanceForm: any) {
  const form = advanceForm;
  const flatControl: any[] = [];
  form.forEach((item: any) => {
    item.layout.forEach((layout: any) => {
      flatControl.push(layout);
    });
  });
  return flatControl;
}
